import { render, staticRenderFns } from "./adminPanel.vue?vue&type=template&id=f2e53006"
import script from "./adminPanel.vue?vue&type=script&lang=js"
export * from "./adminPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports